export function isLastIndex<T>(collection: T[], index: number): boolean {
  return index === collection.length - 1;
}
